import { render, staticRenderFns } from "./select-defaultValue-editor.vue?vue&type=template&id=20391725&scoped=true&"
import script from "./select-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./select-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20391725",
  null
  
)

export default component.exports